var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',[_c('line',{attrs:{"x1":"0","y1":"50%","x2":"100%","y2":"50%","stroke-width":_vm.strokeWidth,"stroke":"currentColor"}}),_c('line',{directives:[{name:"show",rawName:"v-show",value:(!_vm.minus),expression:"!minus"}],attrs:{"x1":"50%","y1":"0%","x2":"50%","y2":"100%","stroke-width":_vm.strokeWidth,"stroke":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }